module.exports = __webpack_public_path__ + "img/3.72cfe0b1.jpg";